(function taraRuntimeFixes() {
  const INGREDIENT_EMPTY_EN = 'No ingredients match your filters. Try adjusting your selection.';
  const INGREDIENT_EMPTY_ES = 'No hemos encontrado ingredientes con esos filtros. Prueba a ajustar la seleccion.';
  const CONTACT_TITLE = 'Contact - Tara USA';

  function normalize(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function normalizeTitle(text) {
    return normalize(text).replace(/\s+[|\\-–]\s+Tara USA$/, '');
  }

  function ensureIngredientEmptyState(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const candidates = scope.querySelectorAll('p, span, div');

    for (const element of candidates) {
      if (element.children.length > 0) continue;
      const value = normalize(element.textContent);
      if (value === INGREDIENT_EMPTY_ES || value === INGREDIENT_EMPTY_EN) {
        element.textContent = INGREDIENT_EMPTY_EN;
      }
    }
  }

  function cleanupLegacyCollectionShell() {
    if (!document.body.classList.contains('template-collection')) return;

    document.querySelectorAll('.collection-editorial').forEach((node) => node.remove());
    document.querySelector('.collection-page-shell__eyebrow')?.remove();
    document.querySelectorAll('.collection-context').forEach((node) => {
      node.closest('.section, .section-wrapper, [id^="shopify-section"]')?.remove();
    });
    document.querySelectorAll('.collection-context__group-heading, .collection-context__cta').forEach((node) => {
      node.closest('.section, .section-wrapper, [id^="shopify-section"]')?.remove();
    });
  }

  function ensureCollectionHeading() {
    if (!document.body.classList.contains('template-collection')) return;
    if (document.querySelector('h1')) return;

    const intro = document.querySelector('.collection-intro');
    const introTitle = intro?.querySelector('.collection-intro__title');
    if (introTitle) {
      const heading = document.createElement('h1');
      heading.className = introTitle.className;
      heading.textContent = introTitle.textContent;
      introTitle.replaceWith(heading);
      return;
    }

    const wrapper = document.querySelector('.collection-wrapper');
    if (!wrapper) return;

    const title = normalizeTitle(document.title);
    if (!title) return;

    const header = document.createElement('header');
    header.className = 'collection-intro page-width-content';
    header.innerHTML = `<h1 class="collection-intro__title">${title}</h1>`;
    wrapper.insertAdjacentElement('beforebegin', header);
  }

  function normalizeContactPage() {
    if (!document.body.className.includes('page-handle-contact')) return;

    document.title = CONTACT_TITLE;

    const heading = document.querySelector('main h1');
    if (heading && normalize(heading.textContent) === 'Contacto') {
      heading.textContent = 'Contact';
    }

    const submit = document.querySelector(
      'form[action*="/contact"] button[type="submit"], form[action*="/contact"] input[type="submit"]'
    );

    if (!submit) return;

    const label = submit.tagName === 'INPUT' ? submit.value : submit.textContent;
    if (normalize(label) === 'Enviar') {
      if (submit.tagName === 'INPUT') {
        submit.value = 'Submit';
      } else {
        submit.textContent = 'Submit';
      }
    }
  }

  function refreshPage() {
    ensureIngredientEmptyState(document);
    cleanupLegacyCollectionShell();
    ensureCollectionHeading();
    normalizeContactPage();
  }

  let scheduled = false;
  function scheduleRefresh() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      refreshPage();
    });
  }

  document.addEventListener('DOMContentLoaded', scheduleRefresh);
  window.addEventListener('load', scheduleRefresh, { once: true });
  setTimeout(scheduleRefresh, 750);

  if (
    document.body.className.includes('page-handle-ingredients') ||
    document.body.classList.contains('template-collection') ||
    document.body.className.includes('page-handle-contact')
  ) {
    const observer = new MutationObserver(() => {
      scheduleRefresh();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
})();
